import script from "./TargetSection.vue?vue&type=script&setup=true&lang=js"
export * from "./TargetSection.vue?vue&type=script&setup=true&lang=js"

import "./TargetSection.vue?vue&type=style&index=0&id=411b821c&scoped=true&lang=scss"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-411b821c"]])

export default __exports__